import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.75",
      d: "M5 6h14v9H9.55L6 17.6V15H5V6Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.45",
      d: "m11.9 8.2.62 1.28 1.41.2-1.02.98.24 1.4-1.25-.67-1.26.67.24-1.4-1.01-.98 1.4-.2.63-1.28Z"
    }, null, -1)
  ]))]))
}
export default { render: render }